// src/services/authService.js

import api from './api';

const login = async (email, password) => {
  console.log(`[Auth Service] Starting login process for email: ${email}`);

  try {
    // Sending login request to backend
    console.log('[Auth Service] Sending login request to the server...');
    const response = await api.post('/auth/login', { email, password });
    
    // Logging the successful response data
    console.log('[Auth Service] Login successful:');
    console.log('[Auth Service] Response Data:', response.data);

    return response.data;
  } catch (error) {
    // Logging the error details if login fails
    console.error('[Auth Service] Login failed:');
    console.error('[Auth Service] Error Response:', error.response?.data);
    console.error('[Auth Service] Error Message:', error.message);

    // Throwing error so that it can be handled by the calling code
    throw error;
  }
};

export default {
  login,
};
